import { Pipe } from '@angular/core';
import type { PipeTransform } from '@angular/core';
import { UtilsService } from '@shared/services';

@Pipe({
    name: 'myPhone',
    'standalone': true
    // pure: true
})
export class MyPhonePipe implements PipeTransform {
    private utilsService: UtilsService = new UtilsService();

    transform(value: unknown): string {
        const phoneNumber = value as string;

        if (!phoneNumber) {
            return '';
        }
        const str = this.utilsService.formatPhoneNumberForDisplay(phoneNumber);
        return str;
    }
}
